import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { GeneralResponse, Token } from "../../../types/api";
import { Methods } from "../../constants/CommonConstants";
import Api from "../axios";
import { EndPoints } from "../endPoints";
import { IFacilityType } from "../../../types/apis/general";

export const fetchFacilityTypes = async (
  token: Token,
): Promise<GeneralResponse<IFacilityType[]>> => {
  return await Api<any, GeneralResponse<IFacilityType[]>>({
    method: Methods.GET,
    endpoint: EndPoints.facilityTypes,
    token: token,
  });
};

export const useFacilityTypesQuery = (token: Token) => {
  return useQuery({
    queryKey: ["facilityTypes", token],
    queryFn: () => fetchFacilityTypes(token),
    staleTime: 0,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchInterval: false,
    enabled: !!token,
  });
};

export const useFacilityTypes = (token: Token) => {
  const {
    data,
    error,
    isLoading,
    isSuccess,
  }: UseQueryResult<GeneralResponse<IFacilityType[]>> =
    useFacilityTypesQuery(token);

  return { data, error, isLoading, isSuccess };
};
